import { FC } from 'react';
import { Skeleton } from 'antd';
import { useGetShareContent } from '@/common/hook/useShareContent';
import V2Empty from '@/common/components/Data/V2Empty';
import YMDecision from '@/common/components/business/ExpandStore/DecisionReportDrawer';
import dayjs from 'dayjs';

const YMDecisionShare: FC = () => {
  const { shareId, shareParams, loading, error } = useGetShareContent();
  if (loading) return <Skeleton active />;
  const { failureTime, token, chancePointId } = shareParams || {};
  if (dayjs().isAfter(failureTime)) {
    location.href = `${process.env.CONSOLE_PC_URL}/share/failure`;
    return <></>;
  }
  // 分享内容缺失/过期/取不到机会点 id 时兜底，避免渲染出一份空报告
  if (!shareId || error || !token || !chancePointId) {
    return <V2Empty type='fail' customTip='分享链接无效或已失效' />;
  }
  return <YMDecision open shared shareParams={shareParams}/>;
};

export default YMDecisionShare;
